export enum OrderTab {
  New = 'new',
  Processed = 'processed',
  Active = 'active',
  Archived = 'archived',
}

export const transformToOrderTab = (value: string): OrderTab => {
  if (!Object.values(OrderTab).includes(value as OrderTab)) {
    throw new Error(`Invalid OrderTab: ${value}`);
  }
  return value as OrderTab;
};

type TabIndex = number;

export const INDEX_BY_ORDER_TAB: Record<OrderTab, TabIndex> = {
  [OrderTab.New]: 0,
  [OrderTab.Active]: 1,
  [OrderTab.Processed]: 2,
  [OrderTab.Archived]: 3,
};

export const ORDER_TAB_BY_INDEX: Record<TabIndex, OrderTab> =
  Object.fromEntries(
    Object.entries(INDEX_BY_ORDER_TAB).map(([key, value]) => [
      value,
      transformToOrderTab(key),
    ]),
  );
